<template>
  <tabs parent="client_request_list">
    <tab id="request_list" :name="translate('client_request.section.request_list')" :href="url+'request_list?&type=1&only_active=1'" >
      <Requests />
    </tab>

    <tab
        id="simcard_list"
        :name="translate('client_request.section.simcard_list')"
        :href="url+'simcard_list?&request_type=1&request_status=1'"
        v-if="$store.getters.getPermissions.permissionGod === true"
    >
      <Simcards />
    </tab>

  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Requests from './Tabs/RequestList/Index.vue'
import Simcards from './Tabs/SimcardList/Index.vue'

export default {
  name: 'ClientRequestList',
  components:{
    Tab,
    Tabs,
    Requests,
    Simcards
  },
  props: {
  },
  data () {
    return {
      load: true,
    }
  },
  computed: {
    url () { return '/client_request_list/' }
  },

}
</script>
